import React from 'react';

import PersonalizationSidebar from 'editor/src/component/PersonalizeLayersContent';

function PersonalizeLayersTabContent() {
  return <PersonalizationSidebar />;
}
export default PersonalizeLayersTabContent;
